import { getDropdownSafeDialogSx } from "../../utils/dialogLayering";
import {
  type ToolAuditLogRow,
  scrollSx,
  formatTimestamp,
  formatDuration,
  formatThreadTimestamp,
  formatParamsAsKeyValue,
  getFullOutputString,
  isErrorRow,
  getActionTypeLabel,
  downloadAuditLogCsv,
} from "../../utils/toolAuditLogUtils";
import {
  createToolAuditLogPopup,
  type ToolAuditChatApi,
} from "./ToolAuditLogPopupCore";

export type { ToolAuditLogRow };

export function buildToolAuditLogPopup(chatApi: ToolAuditChatApi) {
  return createToolAuditLogPopup({
    chatApi,
    helpers: {
      scrollSx,
      formatTimestamp,
      formatDuration,
      formatThreadTimestamp,
      formatParamsAsKeyValue,
      getFullOutputString,
      isErrorRow,
      getActionTypeLabel,
      downloadAuditLogCsv,
    },
    getDropdownSafeDialogSx,
  });
}
